export const iconFontAwesomeUsersPeopleChalkboardUser = (
	<i className="fa-solid fa-chalkboard-user"></i>
);
